<template>
  <transition name="tooltip">
    <div class="step-tooltip" v-if="open">
      <div class="card-image" :style="{'background-image': 'url('+ option.image_url + ')'}">
        <div class="label">{{ option.label }}</div>
        <div class="overlay" :class="[getActiveTheme]"></div>
        <div class="back-btn btn primary small" @click="$emit('previousStep', option)">
          {{ $t('global.word.alter_choice') }}
        </div>
      </div>

      <div class="outside" @click="$emit('close')">
      </div>
    </div>
  </transition>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Tooltip",
  props: {
    option: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean
    }
  },

  computed: {
    ...mapGetters({
      getActiveTheme: 'theme/getActiveTheme',
    }),
  }
}
</script>

<style scoped lang="scss">
.tooltip-enter-active,
.tooltip-leave-active {
  transition: all .3s ease;
}

.tooltip-enter, .tooltip-leave-to {
  transform: scale(0.5);
  opacity: 0;
}

.back-btn {
  z-index: 20;
  display: inline-block;
  background-color: var(--configurator-primary);
}

.step-tooltip {
  cursor: default;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 30px;
  z-index: 9999999;
  width: 215px;
  min-height: 90px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  border-top-left-radius: 0;
  transform-origin: 5px 0;
  overflow: hidden;

  .card-image {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100%;
    padding: 10px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1;

    .overlay {
      top: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      background-color: white;
      opacity: 0.50;
      transform-origin: top right;
      transform: translate(-50px, 50px) rotate(45deg);
      border-radius: 50px;
      width: 1000px;
      height: 1000px;
      transition: all ease-out 0.3s;

      &.kabel-24 {
        left: 0;
        width: 200px;
        height: 200px;
        transform: translate(-30px, -25%);
        border-radius: 50%;
      }
    }

    .label {
      z-index: 1;
      font-weight: var(--configurator-step-label-font-weight);
      font-size: 14px;
      color: var(--configurator-primary);
      margin-bottom: 5px;
    }
  }
}

.outside {
  cursor: default;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}
</style>